import { render, staticRenderFns } from "./DraftCategorySelector.vue?vue&type=template&id=0360a52a&scoped=true&"
import script from "./DraftCategorySelector.vue?vue&type=script&lang=js&"
export * from "./DraftCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./DraftCategorySelector.vue?vue&type=style&index=0&id=0360a52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360a52a",
  null
  
)

export default component.exports